export class QuoteItemModel {
    ProductId: number;
    AddressId: number;
    Id: number;
    Quantity: number = 1;
}

export class QuoteAddressModel {
    addressId: number;
    addressNote: string;
    addressTitle: string;
    city: string;
    country: string;
    dateFormatted: null
    email: string;
    landmark: string;
    phoneNumber: string;
    productId: number;
    quantity: number;
    state: string;
    street: string;
    userId: number
    zipCode: string;
}

export class DeleteQuoteListModel {
    Id: number;
}

export class AdminQuoteListVM {
    PageNumber: number = 1;
    PageSize: number = 10;
    StartDate: string;
    EndDate: string;
}

export class AdminAllQuoteListVM {
    addressId: number;
    addressNote: string;
    addressTitle: string;
    city: string;
    country: string;
    dateFormatted: string;
    landmark: string;
    productId: number;
    productName: string;
    productTitle: string;
    state: string;
    userId: number;
    zipcode: string;
    imageLoader: boolean = true;
    productImage: string;
    id: number;
    phoneNumber: string;
}

export class AllQuoteList {
    AdminQuoteList: Array<AdminAllQuoteListVM> = [];
    TotalPages: number;
}

export class QuoteDetail {
    id: number;
    productId: number;
    addressId: number;
    quantity: number;
}